import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ViewHostBusinessPageNews from "../../components/HostBusiness/ViewHostPageNew";



const ViewHostBusinessPage= () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb id="title" title="View Host Business" title2="Host Business" link2="/host-business" />

        {/* AddUserLayer */}
        <ViewHostBusinessPageNews />


      </MasterLayout>
    </>
  );
};

export default ViewHostBusinessPage;
